import { useEffect } from "react";

// Sets the browser tab title and meta description per page.
// Note: this is client-side, so Google (which renders JS) picks it up, but
// social crawlers (Facebook/WhatsApp) read only the static tags in index.html.
export default function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
  }, [title, description]);
}
